import { Cell } from './ApiKeysPage.styled';
import {
  NAME_COLUMN_VALUE,
  STATUS_COLUMN_VALUE,
  TYPE_COLUMN_VALUE,
  CUSTOM_EVENT_ALLOW_CREATION_UNTIL,
  LAST_MODIFIED_COLUMN_VALUE,
  LAST_USED_COLUMN_VALUE,
  API_KEYS_ACTIONS,
} from '../constants';
import { ApiKeyActionMenu } from './ApiKeyActionMenu';
import {
  NameCell,
  StatusCell,
  TypeCell,
  EventCreationCell,
  LastModifiedCell,
  LastUsedCell,
} from './TableCells';

type TableCellProps = {
  row: any;
  colValue: string;
};

export const TableCell = ({ row, colValue }: TableCellProps) => {
  if (colValue === NAME_COLUMN_VALUE) return <NameCell apiKey={row} />;
  if (colValue === STATUS_COLUMN_VALUE) return <StatusCell apiKey={row} />;
  if (colValue === TYPE_COLUMN_VALUE) return <TypeCell apiKey={row} />;
  if (colValue === CUSTOM_EVENT_ALLOW_CREATION_UNTIL) return <EventCreationCell apiKey={row} />;
  if (colValue === LAST_MODIFIED_COLUMN_VALUE) return <LastModifiedCell apiKey={row} />;
  if (colValue === LAST_USED_COLUMN_VALUE) return <LastUsedCell apiKey={row} />;

  if (colValue === API_KEYS_ACTIONS) {
    return (
      <Cell>
        <ApiKeyActionMenu apiKey={row} />
      </Cell>
    );
  }

  return <Cell>{row[colValue]}</Cell>;
};

export const createRowCell =
  (colValue: string) =>
  ({
    row,
  }: {
    row: Record<string, string | number>;
  }) => {
    return <TableCell row={row} colValue={colValue} />;
  };
